<script setup>
import { ref, onMounted } from 'vue'
import { swalError, swalSuccess } from '@/helper';
// import { retrieve_child, updateLevelUp } from '@/services/child';
// import { get_age_group_ass } from '@/services/assessments';

const props = defineProps({
  notification: {
    type: Object
  }
})

const isLoading = ref(false)
onMounted(async()=>{
  isLoading.value = true
  await get_child_info()
  await get_age_group()
  isLoading.value = false
})

const child = ref({name: ''})
async function get_child_info(){
  let response = await retrieve_child(props.notification.meta.child_id)
  if (response.error){
    swalError(response.result.error)
    child.value = 'Error'
    return 
  }
  // console.log("🚀 ~ get_child_info ~ response:", response)
  child.value = response.result.data.child
}

const age_group = ref({})
async function get_age_group(){
  let trait_id = props.notification.meta.trait_id
  // console.log("🚀 ~ get_age_group ~ trait_id:", trait_id)
  let child_id = child.value.data.id
  // console.log("🚀 ~ get_age_group ~  child.value:",  child.value)
  // console.log("🚀 ~ get_age_group ~ child_id:", child_id)
  let response = await get_age_group_ass(trait_id, child_id)
  // console.log("🚀 ~ get_age_group ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  age_group.value = response.result.data.data
}

const disabledBtn = ref(false)
async function approveLevelUp(notification_id){
  let response = await updateLevelUp(notification_id)
  if (response.error){
    swalError(response.result)
    return
  }
  age_group.value = response.result.data.data
  disabledBtn.value = true
  swalSuccess('Level up request has been updated')
}
</script>

<template>
  <div class="m-2">
    <LoadingCard v-if="isLoading" />
    <div v-else>
      <!-- info -->
      <div>
        <p class="mb-1">
          <span class="fw-semibold tracking-wide">Child Name :</span> 
          {{ child.data?.attributes?.name }}
        </p>
        <p class="mb-1">
          <span class="fw-semibold tracking-wide">Current assessment age group :</span>  
          {{ age_group.attributes?.term_ass_current?.name }}
        </p>
        <p class="mb-1">
          <span class="fw-semibold tracking-wide">Next assessment age group :</span>
          {{ age_group.attributes?.term_ass_next.name }}
        </p>
      </div>
      <div class="mt-3">
        <div>
          <template v-if="notification.attributes.seen_by_user">
            <button class="btn btn-light-primary" disabled>
              Action has been taken
            </button>
          </template>
          <template v-else>
            <button :disabled="disabledBtn" class="btn btn-light-success me-2" @click="approveLevelUp(notification.id)">
              Approve Request
            </button>
            <button :disabled="disabledBtn" class="btn btn-light-danger">
              Reject Request
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>